export default function ($scope, $stateParams, toaster, vmcAccountDetail, getDealerEnquiries, getDealersList, editVmcAccount, deleteVmcAccount, getAccountGroups, $q, $state) {
    const vm = this;

    vm.recordsNotFetched = true;
    vm.errorsOccurred = false;
    vm.noRecords = false;
    vm.records = null;
    vm.vmcAccountId = $stateParams.vmcAccountId;
    vm.searchTerm = '';
    vm.queryInProgress = false;
    vm.vmcAccount = null;
    vm.selectedAccountGroup = null;
    vm.accountGroups = [];

    vm.saveVmcAccount = saveVmcAccount;
    vm.deleteAccount = deleteAccount;

    /* --- */

    $q.all({
        details: vmcAccountDetail(vm.vmcAccountId),
        accountGroups: getAccountGroups()
    })
    .then(({details, accountGroups}) => {
        vm.vmcAccount = details;
        vm.accountGroups = accountGroups;

        vm.selectedAccountGroup = vm.accountGroups.find(x => x.id === vm.vmcAccount.groupId);
    });

    $scope.$watch(() => this.searchTerm, update => {
        getList(update);
    });

    getList();

    /* --- */

    function getList(searchTerm = '') {
        if (vm.queryInProgress) {
            return;
        }

        vm.queryInProgress = true;
        vm.recordsNotFetched = true;
        vm.errorsOccurred = false;
        vm.noRecords = false;

        getDealerEnquiries(vm.vmcAccountId, searchTerm)
            .then(records => {
                vm.queryInProgress = false;
                vm.recordsNotFetched = false;
                vm.records = records;

                if (!records.length) {
                    vm.noRecords = true;
                }
            })
            .catch(() => {
                vm.queryInProgress = false;
                vm.noRecords = false;
                vm.recordsNotFetched = false;
                vm.errorsOccurred = true;
            });
    }

    function saveVmcAccount() {
        if (vm.form.$invalid) {
            return;
        }

        vm.vmcAccount.groupId = vm.selectedAccountGroup == null ?
                                null :
                                vm.selectedAccountGroup.id;

        editVmcAccount(vm.vmcAccount.id, vm.vmcAccount)
        .then(() => {
            toaster.pop('success', 'The account changes were successfully saved');
        })
        .catch(e => {
            toaster.pop('error', e.data);
        });
    }

    function deleteAccount() {
        deleteVmcAccount(vm.vmcAccount.id)
        .then(() => {
            toaster.pop('success', 'The account was deleted');
            $state.go('dealers.list');
        }).catch(e => {
            toaster.pop('error', e.data);  // This does not do what I expect. Help!
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/dealer/controllers/franchiseAndEnquiryDetails/franchiseAndEnquiryDetailsCtrl.js